// color constants
const Colors = {
  PRIMARY: "#191A51",
  PRIMARY1: "191A51",
  SECONDARY: "#FFC107",
  ERROR: "#9D0202",
  ERROR2: "#FF0000",
  SUCCESS: "#029E3B",
  INFO: "#2196F3",
  WARNING: "#FF9800",
  WHITE: "#FFFFFF",
  WHITE_2: "#e0e0e0",
  BLACK: "#000000",
  GREY: "#9E9E9E",
  ARC_INSTALLED_GREEN: "#2E7D32",
  STATUS_Background: "#F5F5F5",
  STATUS_COLOR: "#FFC107",
  LIGHT_YELLOW: "#f7f2e5",
  DARK_YELLOW: "#B68300",
  LIGHT_ORANGE: "#ffefe5",
  DARK_ORANGE: "#ff6600",
  LIGHT_RED: "#9d02021a",
  DARK_RED: "#9D0202",
  LIGHT_GREEN: "#2a8c001a",
  DARK_GREEN: "#2A8C00",
  LIGHT_GRAY: "#E8E8EE",
  LIGHT_GRAY1: "#A0A0A0",
  LIGHT_GRAY2: "#D9D9D9",
  COLLAPSE_BTN: "#FF6600",
  BLACK2: "#101828",
  LIGHT_GRAY3: "#49586D",
  LIGHT_GRAY4: "#E8ECF4",
  LIGHT_GRAY5: "#E4E6E9",
  DARK_GREY: "#475467",
  LIGHT_ORANGE2: "#FEC299",
  LIGHT_BROWN: "#E2B3B4",
  DARK_BROWN: "#9E0003",
  LIGHT_GREEN2: "#CDECD8",
  DARK_GREEN2: "#049E3D",
  LIGHT_YELLOW2: "#EADAB3",
  LIGHT_BLUE: "#BABBCB",
  DARK_BLUE: "#191A51",
  LIGHT_INFO_BLUE: "#2196f31a",
  DARK_INFO_BLUE: "#1976D2",
  DISABLED: "#f0f2f5",
  GREY1: "#e2e8f0",
  PINK: "#FFCCCC",
  LIGHT_PINK: "#FBE4D5",
  LIGHT_ORANGE1: "#FEF2CB",
  LIGHT_GREEN3: "#E2EFD9",
  DARK_RED2: "#F04438",
  DARK_ORANGE2: "#E46A11",
  RATING_0: "gray",
  RATING_1: "#CA0236",
  RATING_2: "#FF5F37",
  RATING_3: "#FAAD02",
  RATING_4: "#FFE009",
  RATING_5: "#26B539",
  TITLE_1: "#667085",
  INPUT_BG: "#f8f7f7",
  BOX_BG: "#FCFCFE",
  TEXT_1: "#191D31",
  TABLE_ROW_COLOR: "#f6f7ff",

  // Material-UI inspired palette for scope coloring (20 colors)
  SCOPE_COLORS: [
    "#f44336", // Red
    "#e91e63", // Pink
    "#9c27b0", // Purple
    "#673ab7", // Deep Purple
    "#3f51b5", // Indigo
    "#2196f3", // Blue
    "#00bcd4", // Cyan
    "#009688", // Teal
    "#4caf50", // Green
    "#ff9800", // Orange
    "#8bc34a", // Light Green
    "#cddc39", // Lime
    "#ffc107", // Amber
    "#ffeb3b", // Yellow
    "#ff5722", // Deep Orange
    "#795548", // Brown
    "#607d8b", // Blue Grey
    "#03a9f4", // Light Blue
    "#9e9d24", // Olive
    "#ad1457", // Dark Pink
  ],
};

export default Colors;
